const apiRouter = process.env.VUE_APP_API_URL;
//'https://bsmstaffcontrol.mbcontrol.cat:44395/';

export default apiRouter